exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.uk-grid > *[data-v-3bd58e92]{\n    padding-left: 2vw;\n}\n.list-box[data-v-3bd58e92]{\n    border: thin solid #707070;\n}\n.list-box-item[data-v-3bd58e92]{\n    padding: 5px;\n    position: relative;\n}\n.list-box-item i[data-v-3bd58e92]{\n    position: absolute;\n    right: 5px;\n    top: 8px;\n}\n", ""]);

// exports
